import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { TicketListV2Component } from "./components/ticket-list/ticket-list.components";
import { TicketService } from "./services/ticket.service";
import { TicketEffects } from "./store/effects/ticket.effects";
import { TicketReducer } from "./store/reducers/ticket.reducer";
import { TicketFormV2Component } from "./components/ticket-form/ticket-form.components";
import { SharedModule } from "../../shared/shared.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { OldTicketService } from './services/old-ticket.service';
import { IncomeSharedModule } from "../shared/income-shared.module";


@NgModule({
  declarations: [
    TicketListV2Component,
    TicketFormV2Component,

  ],
  exports: [
    TicketListV2Component,
    TicketFormV2Component
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    IncomeSharedModule,
    RouterModule,
    FormsModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatOptionModule,
    MatDatepickerModule,

    DragDropModule,

    // NgRx
    StoreModule.forFeature('ticket', TicketReducer),
    EffectsModule.forFeature([TicketEffects])
  ],
  providers: [
    TicketService,
    OldTicketService,
    DatePipe
  ]
})

export class TicketModule { }
